/* eslint-disable react/require-default-props */
import React from "react"
import {NextThemeProvider, ThemeModel} from "@next/ux-fabric"
import {ThemeProvider, Direction, createTheme} from "@mui/material/styles"
import Footer from "./compositions/footer"
import {globalStyle} from "./GlobalStyle"
import Copyright from "./components/Copyright"
import {IS_BROWSER} from "./utils/window"
import {FOOTER_MFE_ID} from "./config/constants"

interface MyAppProps {
    isConfError: boolean
    appScope: string
    themeVersion: string
    uxFabric?: ThemeModel
    textAlignment: Direction
    realm: string
}

export const App: React.FC<MyAppProps> & any = (props: MyAppProps) => {
    const theme = IS_BROWSER() ? (window as any).uxFabric[`${props.themeVersion}-${props.realm}`] : props.uxFabric

    return (
        <div className="App">
            {globalStyle}
            {props.isConfError ? (
                <ThemeProvider theme={createTheme()}>
                    <div id={FOOTER_MFE_ID}>
                        <div
                            id="platform_modernisation_footer"
                            className="x-next-plat-mod"
                            style={{fontFamily: "AzoSansRegular", textAlign: "center"}}
                        >
                            <Copyright />
                        </div>
                    </div>
                </ThemeProvider>
            ) : (
                <NextThemeProvider uxfabric={theme} textAlignment={props.textAlignment}>
                    <div id={FOOTER_MFE_ID}>
                        <div className="x-next-plat-mod" id="platform_modernisation_footer">
                            <Footer {...props} />
                        </div>
                    </div>
                </NextThemeProvider>
            )}
        </div>
    )
}

export default App
